import { Link } from "react-router-dom";
import { NAV_LINKS, LEGAL_LINKS } from "@/data/nav";
import { openCookieSettings } from "@/lib/consent";
import { KingsmossFooterLink } from "@/components/site/Kingsmoss";
import SEO from "@/data/seo-pages.json";

const Col = ({ title, children }) => (
  <div>
    <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D4A437]">{title}</h3>
    <ul className="mt-5 space-y-3 text-sm">{children}</ul>
  </div>
);

const FLink = ({ to, children }) => (
  <li>
    <Link to={to} className="text-[#F7F5F0]/70 transition-colors hover:text-[#FF6A00]">{children}</Link>
  </li>
);

export const Footer = () => (
  <footer className="border-t border-[#1d1d1d] bg-[#050505] pb-24 lg:pb-0" data-testid="site-footer">
    <div className="lc-container grid gap-12 py-16 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <img src="/brand/weelogrun-512.png" alt="WeeLogRun Firewood Subscription logo" width="160" height="160" className="h-40 w-40 rounded-full" loading="lazy" />
        <p className="mt-6 max-w-xs text-sm leading-relaxed text-[#A1A1AA]">
          Your local log membership delivery team for Newtownabbey and surrounding areas — BT36, BT37, BT38 and BT39.
        </p>
      </div>
      <div className="grid grid-cols-2 gap-10 sm:grid-cols-4 lg:col-span-8">
        <Col title="Explore">
          {NAV_LINKS.map((l) => <FLink key={l.to} to={l.to}>{l.label}</FLink>)}
        </Col>
        <Col title="Members">
          <FLink to="/account">My WeeLogRun</FLink>
          <FLink to="/plans">Start a subscription</FLink>
          <FLink to="/delivery-areas">Check your postcode</FLink>
          <FLink to="/guides">Firewood guides</FLink>
        </Col>
        <Col title="Log delivery">
          {SEO.areas.map((a) => <FLink key={a.slug} to={`/log-delivery/${a.slug}`}>{a.name}</FLink>)}
        </Col>
        <Col title="Legal">
          {LEGAL_LINKS.map((l) => <FLink key={l.to} to={l.to}>{l.label}</FLink>)}
          <li>
            <button onClick={openCookieSettings} className="text-[#F7F5F0]/70 hover:text-[#FF6A00]" data-testid="footer-cookie-settings">
              Cookie settings
            </button>
          </li>
        </Col>
      </div>
    </div>
    <div className="border-t border-[#161616]">
      <div className="lc-container flex flex-col gap-2 py-6 text-xs text-[#6f6f6f] sm:flex-row sm:justify-between">
        <p>© {new Date().getFullYear()} WeeLogRun. All rights reserved.</p>
        <KingsmossFooterLink />
        <p>Northern Ireland firewood subscription</p>
      </div>
    </div>
  </footer>
);
